export { default } from './account.component';